module.exports = __webpack_public_path__ + "img/three-dots.49d881fd.svg";